import * as React from "react";
import { size, groupBy, filter } from "lodash";
import { Form, FormState } from "informedv4";
import Alert, { AlertCategoryEnum } from "../../../misc/components/Alert";
import { FixedCommentSetFormModel, FixedCommentEntries } from "../Types";
import FixedCommentsFormBody from "./FixedCommentSetFormBody";
import { FixedCommentsFormButtons } from "./FixedCommentFormButtons";
import useOrderedComments from "./UserOrderedComments";

interface FixedCommentSetFormProps {
    onSubmit: (values: FormState) => void;
    initialCommentsFormValues: FixedCommentSetFormModel;
    title: string;
    editMode: boolean;
    error: string;
}

export const FixedCommentSetForm = ({ onSubmit, initialCommentsFormValues, title, editMode, error }: FixedCommentSetFormProps): JSX.Element => {
    const formValidator = (values: FixedCommentSetFormModel) => {

        if (!values?.Comments || !size(values?.Comments)) {
            return "There must be at least one fixed comment";
        }

        const duplicateComments = filter(groupBy(values.Comments, c => c.comment), g => g.length > 1);

        if (duplicateComments.length > 0) {
            return "Two comments cannot have the same display text";
        }

        const duplicateDescriptions = filter(groupBy(filter(values.Comments, c => c.description !== "" && c.description !== undefined && c.description !== null), c => c.description), g => g.length > 1);

        if (duplicateDescriptions.length > 0) {
            return "Two comment descriptions cannot have the same text";
        }

        return null;
    }

    const { reset, ...commentProps } = useOrderedComments(initialCommentsFormValues?.Comments);

    const handleImportComments = (entries: FixedCommentEntries) => {
        reset(entries);
    }
    
    return (
        <div>
            <Form id="fixedCommentsForm" initialValues={initialCommentsFormValues as unknown as Record<string, unknown>} validateOn="submit" validate={formValidator} onSubmit={onSubmit}>
                {({ formState, formApi }) =>
                (<>
                    <Alert show={formState.error} category={AlertCategoryEnum.Danger}>
                        {formState.error}
                    </Alert>
                    <Alert show={!!error} category={AlertCategoryEnum.Danger}>
                        {error}
                    </Alert>
                    <div className="row">
                        <div className="col-md-6">
                            <h2 className="text-primary">{title}</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="panel">
                                <div className="panel-body">
                                    <div id="fixedCommentsList">
                                        <FixedCommentsFormBody {...commentProps} initialState={initialCommentsFormValues} editMode={editMode}  />
                                    </div>
                                </div>
                                <div className="ibox-footer">
                                    <FixedCommentsFormButtons onSubmit={onSubmit} onImportComments={handleImportComments} />
                                </div>
                            </div>
                        </div>
                    </div></>)}
            </Form>
        </div>
    );
};
